export const ccTypeToCode = {
  VISA: '001',
  MASTERCARD: '002',
  AMERICANEXPRESS: '003',
  DISCOVER: '004',
  DINERS: '006',
  XBUCK: '100',
};

export const ccCodeToType = {
  '001': 'Visa',
  '002': 'MasterCard',
  '003': 'AMEX',
  '004': 'Discover',
  '006': 'Diners',
  100: 'XBUCK',
};

export function getCcTypeCode(type) {
  if (!type) return type;
  return ccTypeToCode[type.toUpperCase()] || type;
}

export function getCcTypeString(code) {
  return ccCodeToType[code] || code;
}
